import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faFacebook,
  faPinterest,
  faTwitter,
  faInstagram,
  faSnapchat,
  faTelegram,
  faLine,
  faTiktok,
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import {
  faEye,
  faMale,
  faFemale,
  faHeart,
  faAngleDown,
  faAngleUp
} from '@fortawesome/free-solid-svg-icons';

library.add(faFacebook);
library.add(faTwitter);
library.add(faInstagram);
library.add(faSnapchat);
library.add(faPinterest);
library.add(faTelegram);
library.add(faLine);
library.add(faTiktok);
library.add(faWhatsapp);

library.add(faEye);
library.add(faMale);
library.add(faFemale);
library.add(faHeart);
library.add(faAngleDown);
library.add(faAngleUp);
